import { ChevronLeft, ExpandMore } from '@mui/icons-material';
import { Accordion, AccordionDetails, AccordionSummary, Box, Divider, Grid, Typography } from '@mui/material';
import React, { Component } from 'react';
import NavbarMobile from '../../Tools/NavbarMobile';
import Filter from './Filter';

class CrossLeadsReportMobile extends Component {
    state = {  } 
    render() { 
        return (
        <Box>
            <NavbarMobile title={"Cross Leads(Semua Data)"} {...this.props} />
            <Box sx={{padding: "10px"}}>
                <Filter {...this.props} />
                {
                    this.props.crossedLeads.map((lead,index) => {
                        return (
                            // <TableCell>{item.crossedOwnerName2}</TableCell>
                            // <TableCell>{item.firstContactAssignedToName}</TableCell>
                            // <TableCell>{item.fromName}</TableCell>
                            // <TableCell>{item.from}</TableCell>
                            // <TableCell>{item.label}</TableCell>
                            <Accordion key={`cross-${index}`}>
                                <AccordionSummary
                                    expandIcon={<ExpandMore />}
                                    aria-controls="panel1-content"
                                    id="panel1-header"
                                >
                                    <Grid container spacing={1}>
                                        <Grid item xs={7}>
                                            <Typography component="span">Sales Cross</Typography>
                                        </Grid>
                                        <Grid item xs={5} textAlign={"right"} sx={{pr: "5px"}}>
                                            {lead.crossedOwnerName2} leads
                                        </Grid>
                                    </Grid>
                                    <Grid container spacing={1}>
                                        <Grid item xs={7}>
                                            <Typography component="span">Sales Pertama</Typography>
                                        </Grid>
                                        <Grid item xs={5} textAlign={"right"} sx={{pr: "5px"}}>
                                            {lead.firstContactAssignedToName} leads
                                        </Grid>
                                    </Grid>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <Grid container spacing={1}>
                                        <Grid item xs={12}>
                                            <Typography component="span">{lead.fromName}</Typography>
                                        </Grid>
                                    </Grid>
                                    <Divider />
                                    <Grid container spacing={1}>
                                        <Grid item xs={5}>
                                            <Typography component="span">{lead.from}</Typography>
                                        </Grid>
                                        <Grid item xs={7} textAlign={"right"} sx={{pr: "5px"}}>
                                            {lead.label}
                                        </Grid>
                                    </Grid>
                                </AccordionDetails>
                            </Accordion>
                        );
                    })
                }
            </Box>
        </Box>
        );
    }
}
 
export default CrossLeadsReportMobile;